import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class OrderRecipientCompanyNameEmptyError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'data-model.orders.recipient.validation.company-name.required');
    }
}
